import styled from "styled-components";

export const SpinnerStyled = styled.div`
  left: 50%;
  position: fixed;
  z-index: 9999;
  top: 300px;
  margin-left: -30px;
`;
